var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UnlayerWrapperComponent',{ref:"emailEditor",attrs:{"userId":_vm.currentCompanyId,"design":_vm.designObject,"locale":_vm.locale},on:{"designSaved":_vm.on_design_saved,"plaintextGenerated":_vm.on_plaintext_generated,"auto_save":_vm.on_auto_save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }